import "./Menu.scss";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import useUser from "../../data/useUser";
import useAdminUser from "../../data/useAdminUser";
import { getDomainConfig } from "../../configs/main";
import { useDispatch } from "react-redux";
import { setSupportOrigin } from "../../redux/pageContext/actions";


function Menu() {
  const userData = useUser()
  const adminData = useAdminUser()
  const dispatch = useDispatch();
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);

  const supportEmail = "techsupport@retargeo.ru";
  const encodedSupportEmail = encodeURIComponent(supportEmail);

  const emailClients = [
    {
      label: "mail.ru",
      url: `https://e.mail.ru/compose/?to=${encodedSupportEmail}`,
      iconUrl: "https://logo.clearbit.com/mail.ru",
      fallbackIconUrl: "https://www.google.com/s2/favicons?domain=mail.ru&sz=64",
    },
    {
      label: "Яндекс Почта",
      url: `https://mail.yandex.ru/compose?to=${encodedSupportEmail}`,
      iconUrl: "https://logo.clearbit.com/yandex.ru",
      fallbackIconUrl: "https://www.google.com/s2/favicons?domain=yandex.ru&sz=64",
    },
    {
      label: "Gmail",
      url: `https://mail.google.com/mail/?view=cm&fs=1&to=${encodedSupportEmail}`,
      iconUrl: "https://logo.clearbit.com/gmail.com",
      fallbackIconUrl: "https://www.google.com/s2/favicons?domain=gmail.com&sz=64",
    },
    {
      label: "Microsoft Outlook",
      url: `https://outlook.office.com/mail/deeplink/compose?to=${encodedSupportEmail}`,
      iconUrl: "https://logo.clearbit.com/outlook.com",
      fallbackIconUrl: "https://www.google.com/s2/favicons?domain=outlook.com&sz=64",
    },
    {
      label: "iCloud Mail",
      url: `https://www.icloud.com/mail/compose?to=${encodedSupportEmail}`,
      iconUrl: "https://logo.clearbit.com/icloud.com",
      fallbackIconUrl: "https://www.google.com/s2/favicons?domain=icloud.com&sz=64",
    },
  ];

  const handleSupportClick = () => {
    dispatch(setSupportOrigin("menu_button"));
    setIsSupportModalOpen(true);
  };

  const handleClientSelect = (url) => {
    window.open(url, "_blank");
    setIsSupportModalOpen(false);
  };

  return (
    <div className="Menu">
      {!["ADMIN", "MANAGER", "SUPERUSER"].some((el) => adminData.role === el) && userData.user.id == "84149b79-02d9-4919-8a92-e2531594dc4b" ? (
        <div className="menu-container">
          <NavLink to="/statistics">Статистика</NavLink>
        </div>
      ) : (
        <div className="menu-container">
          <NavLink end to="/">
            Кампании
          </NavLink>
          {!(userData.user.id === "d13b7ea6-4c0b-43f6-905f-6780abda0f96" && !["ADMIN", "MANAGER", "SUPERUSER"].some((el) => adminData.role === el)) && <NavLink to="/add-company">Добавить кампанию</NavLink>}
          <NavLink to="/statistics">Статистика</NavLink>
          {userData.user.agency !== "click_ru_753" && <NavLink to="/finance">Финансы</NavLink>}
          <NavLink to="/counters">Счётчики</NavLink>
          <NavLink to="/archive-campaigns">Архивные кампании</NavLink>
          {/* <NavLink to="/ai-creatives">AI Креативы</NavLink> */}
          {
            (getDomainConfig().brand === "retargeo" || getDomainConfig().title === "Programmatic Beta") && (
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginLeft: "auto" }}>
                <button
                  style={{ width: "fit-content", backgroundColor: "#3f73f9", color: "#fff", padding: "8px 15px", fontSize: 14, borderRadius: 5, display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}
                  onClick={handleSupportClick}
                >
                  Связаться с поддержкой
                  <svg style={{ marginTop: 1 }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fafafa" viewBox="0 0 256 256"><path d="M228.88,26.19a9,9,0,0,0-9.16-1.57L17.06,103.93a14.22,14.22,0,0,0,2.43,27.21L72,141.45V200a15.92,15.92,0,0,0,10,14.83,15.91,15.91,0,0,0,17.51-3.73l25.32-26.26L165,220a15.88,15.88,0,0,0,10.51,4,16.3,16.3,0,0,0,5-.79,15.85,15.85,0,0,0,10.67-11.63L231.77,35A9,9,0,0,0,228.88,26.19Zm-61.14,36L78.15,126.35l-49.6-9.73ZM88,200V152.52l24.79,21.74Zm87.53,8L92.85,135.5l119-85.29Z"></path></svg>
                </button>
                {isSupportModalOpen && (
                  <div
                    style={{
                      position: "fixed",
                      inset: 0,
                      backgroundColor: "rgba(0, 0, 0, 0.45)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 1000,
                    }}
                    onClick={() => setIsSupportModalOpen(false)}
                  >
                    <div
                      style={{
                        width: "100%",
                        maxWidth: 420,
                        backgroundColor: "#fff",
                        borderRadius: 10,
                        padding: 20,
                        boxSizing: "border-box",
                        display: "flex",
                        flexDirection: "column",
                        gap: 10,
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div style={{ fontSize: 18, fontWeight: 600 }}>Выберите почтовый клиент</div>
                      {emailClients.map((client) => (
                        <button
                          key={client.label}
                          style={{
                            width: "100%",
                            padding: "10px 12px",
                            border: "1px solid #d9d9d9",
                            borderRadius: 8,
                            backgroundColor: "#fff",
                            cursor: "pointer",
                            textAlign: "left",
                            fontSize: 14,
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                          }}
                          onClick={() => handleClientSelect(client.url)}
                        >
                          <img
                            src={client.iconUrl}
                            alt={client.label}
                            onError={(e) => {
                              if (e.currentTarget.src !== client.fallbackIconUrl) {
                                e.currentTarget.src = client.fallbackIconUrl;
                              }
                            }}
                            style={{
                              width: 24,
                              height: 24,
                              borderRadius: "50%",
                              objectFit: "cover",
                              flexShrink: 0,
                            }}
                          />
                          {client.label}
                        </button>
                      ))}
                      <button
                        style={{
                          marginTop: 4,
                          width: "100%",
                          padding: "10px 12px",
                          border: "none",
                          borderRadius: 8,
                          backgroundColor: "#f2f2f2",
                          cursor: "pointer",
                          fontSize: 14,
                        }}
                        onClick={() => setIsSupportModalOpen(false)}
                      >
                        Отмена
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )
          }

        </div>
      )}

    </div>
  );
}

export default Menu;
